import React from "react";

const InfoCard = ({ icon, title, content, bgColor, titleColor }) => {
  return (
    <div className={`rounded-2xl p-6 ${bgColor} w-full flex flex-col items-start gap-4`}>
      <p className={`flex gap-1 items-center w-full text-sm ${titleColor} font-semibold`}>
        {icon}
        {title}
      </p>
      <div className="text-grey-primary text-xs">
        {content}
      </div>
    </div>
  )
}

export default InfoCard;
